export default [
  {
    id: 'todas',
    name: 'Todas',
    children: [
      {
        id: 'cadastros:acessar',
        name: 'Cadastros',
        children: [
          {
            id: 'clientes',
            name: 'Clientes',
            children: [
              { id: 'clientes:acessar', name: 'Acessar' },
              { id: 'clientes:cadastrar', name: 'Cadastrar' },
              { id: 'clientes:alterar', name: 'Alterar' },
              { id: 'clientes:excluir', name: 'Excluir' },
            ],
          },
          {
            id: 'fornecedores_acessar',
            name: 'Fornecedores',
            children: [
              { id: 'fornecedores:acessar', name: 'Acessar' },
              { id: 'fornecedores:cadastrar', name: 'Cadastrar' },
              { id: 'fornecedores:alterar', name: 'Alterar' },
              { id: 'fornecedores:excluir', name: 'Excluir' },
            ],
          },
          {
            id: 'vendedores_acessar',
            name: 'Vendedores',
            children: [
              { id: 'vendedores:acessar', name: 'Acessar' },
              { id: 'vendedores:cadastrar', name: 'Cadastrar' },
              { id: 'vendedores:alterar', name: 'Alterar' },
              { id: 'vendedores:excluir', name: 'Excluir' },
            ],
          },
        ],
      },
      {
        id: 'produtos',
        name: 'Produtos',
        children: [
          { id: 'produtos_acessar', name: 'Cadastro de Produtos',
            children: [
                { id: 'produtos:acessar', name: 'Acessar' },
                { id: 'produtos:cadastrar', name: 'Cadastrar' },
                { id: 'produtos:alterar', name: 'Alterar' },
                { id: 'produtos:excluir', name: 'Excluir' },
                { id: 'produtos:alterar_referencia_produto', name: 'Alterar Referência do Produto' },
              ],
          },
          { 
            id: 'pedidoscompra', 
            name: 'Pedidos de Compra',
            children: [
              { id: 'pedidoscompra:acessar', name: 'Acessar' },
              { id: 'pedidoscompra:cadastrar', name: 'Cadastrar' },
              { id: 'pedidoscompra:alterar', name: 'Alterar' },
              { id: 'pedidoscompra:excluir', name: 'Excluir' },
            ],
          },
          { id: 'movimentoestoque_acessar', name: 'Movimento de Estoque',
            children: [
              { id: 'movimentoestoque:acessar', name: 'Acessar' },
              { id: 'movimentoestoque:cadastrar', name: 'Cadastrar' },
              { id: 'movimentoestoque:alterar', name: 'Alterar' },
              { id: 'movimentoestoque:excluir', name: 'Excluir' },
            ],
          },
          { id: 'controle_produtos:acessar', name: 'Controle de Produtos' },
          { id: 'etiquetas:acessar', name: 'Etiquetas' },
          { id: 'balanco:acessar', name: 'Balanço' },
          { id: 'grupos_produtos:acessar', name: 'Grupos de Produtos' },
          { id: 'variacoes:acessar', name: 'Variações/Grades' },
        ],
      },
      {
        id: 'vendas',
        name: 'Vendas',
        children: [
          { id: 'pedidos_acessar', name: 'Pedidos',
            children: [
                { id: 'pedidos:acessar', name: 'Acessar' },
                { id: 'pedidos:cadastrar', name: 'Cadastrar' },
                { id: 'pedidos:alterar', name: 'Alterar' },
                { id: 'pedidos:faturar', name: 'Faturar' },
                { id: 'pedidos:estornar', name: 'Estornar' },
                { id: 'pedidos:cancelar', name: 'Cancelar' },
                { id: 'pedidos:alterar_data', name: 'Alterar Data da Venda' },
              ],
          },
          { id: 'devolucoes:acessar', name: 'Devoluções' },
        ],
      },
      {
        id: 'cheques',
        name: 'Cheques',
        children: [
          { id: 'cheques_acessar', name: 'Cadastro de Cheques',
            children: [
                { id: 'cheques:acessar', name: 'Acessar' },
                { id: 'cheques:cadastrar', name: 'Cadastrar' },
                { id: 'cheques:alterar', name: 'Alterar' },
                { id: 'cheques:excluir', name: 'Excluir' },
                { id: 'cheques:status', name: 'Mudar Status' },
              ],
           },
          { id: 'remessascheques:acessar', name: 'Remessa de Cheques' },
        ],
      },
      {
        id: 'financeiro',
        name: 'Financeiro',
        children: [
          { id: 'extrato:acessar', name: 'Extrato do Cliente' },
          { id: 'extratofornecedor:acessar', name: 'Extrato do Fornecedor' },
          { id: 'contasrecerber:acessar', name: 'Contas a Receber' },
          { id: 'recebimentos:acessar', name: 'Recebimentos' },
          { id: 'caixa:acessar', name: 'Caixa' },
          { id: 'contaspagar:acessar', name: 'Contas a Pagar' },
          { id: 'compartilharcontas:acessar', name: 'Compartilhar Contas' },
        ],
      },
      {
        id: 'relatorios',
        name: 'Relatórios',
        // children: [
        //   { id: 7, name: 'Cadastro de Produtos' },
        //   { id: 8, name: 'Movimento de Estoque' }
        // ]
      },
      {
        id: 'sistema',
        name: 'Sistema',
        children: [
          { 
            id: 'usuarios', 
            name: 'Usuários',
            children: [
              { id: 'usuarios:cadastrar', name: 'Cadastrar' },
              { id: 'usuarios:alterar', name: 'Alterar' },
              { id: 'usuarios:excluir', name: 'Excluir' },
              { id: 'usuarios:impersonate', name: 'Impersonate' },
              { id: 'usuarios:permissoes', name: 'Acessar Permissões' }
            ],
          },
          { id: 'lojas:acessar', name: 'Lojas' },
          { id: 'lojas:trocar', name: 'Trocar de Lojas' },
          { id: 'configuracoes_avancadas:acessar', name: 'Acessar as Configurações Avançadas' },
          { id: 'configuracoes:acessar', name: 'Acessar as Configurações' },
          { id: 'whatsapp:acessar', name: 'Whatsapp' },
        ],
      },
    ],
  },
];
